<template>
  <v-sheet class="container-user">
    <div v-if="user">
      <div id="user_chip" class="bg-primary">
        <div>
          <h3>{{ user.name }}</h3>
          <h4>{{ user.email }}</h4>
        </div>
        <div>
          <v-btn variant="plain" icon size="default" @click="auth.switchTenant()">
            <v-icon>mdi-swap-horizontal</v-icon>
            <v-tooltip activator="parent" location="bottom">{{ $t('common.actions.switchTenant') }}</v-tooltip>
          </v-btn>
          <v-btn variant="plain" icon size="default" @click="signOut">
            <v-icon>mdi-logout</v-icon>
            <v-tooltip activator="parent" location="bottom">{{ $t('common.actions.logout') }}</v-tooltip>
          </v-btn>
        </div>
      </div>
    </div>
    <div class="d-flex flex-column flex-grow-1">
      <div class="list-box flex-grow-1">
        <v-list-item v-for="(item, index) in itemsMenu" :key="index" :value="index" :data-testid="item.testId" @click="item.action">
          <v-list-item-title class="pl-5 py-2">
            <v-icon size="small" :color="item.color" class="mr-4">{{ item.icon }}</v-icon>
            {{ item.title }}
          </v-list-item-title>
        </v-list-item>
        <!-- <div class="pa-3 pl-4 pr-4">
          <p>{{ $t("views.userSettings.selectLanguage") }}</p>
          <v-select
            hide-details
            density="compact"
            class="mt-2"
            :items="supportedLocales"
            v-model="lang"
            item-title="text"
            item-value="value"
            @update:modelValue="locale = lang"
          ></v-select>
        </div>
        -->
      </div>
      <div class="version-box pa-4 bodyTextsSmall">
        <p>
          <strong>{{ $t('views.userMenu.builtByCompany', { company: 'Technosylva' }) }}</strong>
        </p>
        <p>v0.3.1</p>
      </div>
    </div>
  </v-sheet>
  <v-dialog v-model="openUserSettings"><UserSettings @close="openUserSettings = false"></UserSettings></v-dialog>
</template>

<script lang="ts" setup>
import { computed, onMounted, ref } from 'vue'

import { storeToRefs } from 'pinia'

import { useI18n } from 'vue-i18n'

import { useNotifications } from '@tsyl/zapan2'

import UserSettings from '@/components/User/UserSettings.vue'
import AuthStore from '@/stores/auth'
import emitter from '@/utils/EventBus'

const { t } = useI18n()

const { addNotification } = useNotifications()

const auth = AuthStore()
const { user } = storeToRefs(auth)

const openUserSettings = ref(false)

const isUserLogged = computed(() => {
  return user !== undefined && !!user.value
})

const itemsMenu = computed(() => {
  const items: { title: string; icon: string; color: string; action: () => void; testId?: string }[] = [
    // {
    //   title: t("common.concepts.home"),
    //   icon: "mdi-home",
    //   color: "rgb(var(--v-theme-myDark))",
    //   action: () => {
    //     console.info("(WIP)")
    //   },
    // },
  ]

  items.push(
    {
      title: t('common.concepts.tour'),
      icon: 'mdi-information',
      color: 'rgb(var(--v-theme-myDark))',
      action: () => {
        emitter.emit('startTour')
      }
    },
    {
      title: t('common.concepts.disclaimer'),
      icon: 'mdi-clipboard-text',
      color: 'rgb(var(--v-theme-myDark))',
      action: () => {
        console.info('(WIP)')
      }
    },
    {
      title: t('common.concepts.settings'),
      icon: 'mdi-cog',
      color: 'rgb(var(--v-theme-myDark))',
      action: () => {
        openUserSettings.value = true
      }
    }
  )

  if (!isUserLogged.value) {
    items.push({
      title: t('common.actions.login'),
      icon: 'mdi-login',
      color: 'rgb(var(--v-theme-myDark))',
      testId: 'user-menu-login',
      action: () => {
        auth.login()
      }
    })
  }

  return items
})

function signOut() {
  user.value = null
  auth.logout()
}

onMounted(() => {
  if (auth.switchTenantNoop) {
    addNotification({
      type: 'info',
      title: t('messages.info.noOtherTenant'),
      time: 6000
    })
    auth.switchTenantNoop = false
  }
})

// onBeforeMount(() => {
//   router.isReady().then(() => {
//     const routeName = router.currentRoute.value.name
//     // if (routeName === 'user')
//     authenticateUser(realm)
//   })
// })
</script>

<style lang="scss">
.login-menu .v-overlay__content {
  display: flex !important;
  flex-direction: column !important;
  justify-content: center !important;
  overflow-y: hidden;
}
</style>

<style scoped lang="scss">
.user-menu {
  width: 500px;
  max-height: 90vh;
}

.user-list {
  width: 90vw;
}

.login-menu {
  width: 750px;
  height: 500px;
}

.container-user {
  display: flex;
  flex-direction: column;
  height: 100vh;
}
.v-list-item:hover {
  cursor: pointer;
  background-color: rgba(var(--v-theme-primary), 0.35) !important;
}
.signOut:hover {
  cursor: pointer;
  opacity: 0.67;
}

#user_chip {
  display: flex;
  justify-content: space-between;
  padding: 10px;
  align-items: center;
  //border-top: 10px solid rgb(var(--v-theme-background));
}

.version-box {
  background-color: rgb(var(--v-theme-surface-light));
}
</style>
